var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 110,
    viewBox: "0 0 145 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_81_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0572 100C14.6284 98.248 13.7312 94.3868 13.5729 93.3554C13.4145 92.3239 14.4964 90.8099 15.0572 90.1818L12.4843 56.3631L15.0572 50.7101V48.0324C15.486 47.5034 16.5019 45.9695 17.1353 44.0653C17.9269 41.6851 14.9582 38.0157 16.3436 37.1231C16.2447 36.3297 16.5019 34.5842 18.3227 33.9495C17.696 32.3627 17.4717 28.6536 21.5883 26.5114C22.0501 24.9907 23.9632 21.9295 27.9215 21.8501C28.6141 20.4286 30.9693 17.8633 34.8484 18.9741C35.5081 18.2798 36.9354 16.4207 39.3895 16.5C39.6533 16.4339 40.8847 14.6942 40.8847 14C41.043 14.7934 42.1256 16.4339 42.3895 16.5C44.8436 16.4207 46.2613 18.2798 46.921 18.9741C50.8 17.8633 53.1552 20.4286 53.8479 21.8501C57.8061 21.9295 59.7193 24.9907 60.1811 26.5114C64.2976 28.6536 64.0733 32.3627 63.4466 33.9495C65.2674 34.5842 65.5247 36.3297 65.4257 37.1231C66.8111 38.0157 63.8424 41.6852 64.6341 44.0654C65.2674 45.9695 66.2833 47.5034 66.7122 48.0324L66.8111 50.8093L69.384 56.4623L66.8111 90.2809C67.3719 90.9091 68.4538 92.4231 68.2954 93.4546C68.1371 94.486 67.2399 98.248 66.8111 100H70.8683L78.1889 100M15.0572 100H11L6 100V2L100.864 2.00011H139V100L134 100H129.943M15.0572 100L65.4257 100M78.1889 100C77.7601 98.2479 76.8629 94.3867 76.7046 93.3553C76.5462 92.3238 77.6281 90.8098 78.1889 90.1817L75.616 56.363L78.1889 50.71V48.0322C78.6177 47.5033 79.6337 45.9694 80.267 44.0652C81.0586 41.685 78.0899 38.0156 79.4753 37.123C79.3764 36.3296 79.6336 34.5841 81.4544 33.9494C80.8277 32.3626 80.6034 28.6534 84.72 26.5113C85.1818 24.9906 87.0949 21.9294 91.0532 21.85C91.7458 20.4285 94.101 17.8632 97.9801 18.974C98.6398 18.2797 99.6988 16.4206 102.153 16.4999C102.417 16.4338 104.016 14.6941 104.016 13.9999C104.175 14.7933 105.389 16.4338 105.653 16.4999C108.107 16.4206 109.393 18.2797 110.053 18.974C113.932 17.8632 116.287 20.4285 116.98 21.85C120.938 21.9294 122.851 24.9906 123.313 26.5113C127.429 28.6534 127.205 32.3626 126.578 33.9494C128.399 34.5841 128.656 36.3296 128.557 37.123C129.943 38.0156 126.974 41.685 127.766 44.0653C128.399 45.9694 129.415 47.5033 129.844 48.0323L129.943 50.8092L132.516 56.4621L129.943 90.2808C130.504 90.9089 131.585 92.423 131.427 93.4544C131.269 94.4859 130.372 98.2479 129.943 100M78.1889 100H129.943",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_81_11",
    x: 0,
    y: 0,
    width: 145,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81_11",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelIcon);
export default __webpack_public_path__ + "static/media/model-icon.b4f1baeabd1a9711954338355a00e3f2.svg";
export { ForwardRef as ReactComponent };